import loadergif from './Loading.gif';

const ChickenSpinner = () => (
  <img alt="Loading" draggable={false} src={loadergif} className="w-[100px]" />
);

export default ChickenSpinner;
